import { makeStyles } from '@material-ui/core/styles';
import Image from 'next/image';
import React from 'react';
import logo from '../../public/assets/nmd-dark.png';

const useStyles = makeStyles(() => ({
  container: {
    borderRadius: 5,
    overflow: 'hidden',
  },
}));

interface LogoProps {
  height?: number;
}

export default function Logo({ height = 43 }: LogoProps): JSX.Element {
  const classes = useStyles();

  return (
    <div className={classes.container} style={{ height, width: height }}>
      <Image src={logo} />
    </div>
  );
}
